import { ProductDetails_attributes } from "@the-volte/svc-core-sdk/lib/fragments/gqlTypes/ProductDetails";

export const getAttributeValue = (
  attrName: string,
  attributes: ProductDetails_attributes[]
) => {
  if (!attributes) return "";

  return (
    attributes.find((attr) => attr.attribute.slug === attrName)?.values?.[0]
      ?.name ?? ""
  );
};
